<template>
  <label 
    v-if="isEditable" 
    for="subject-line"
    class="subject-line subject-line--editable"
  >
    <span class="subject-line__label">Subject: </span>
    <input 
      id="subject-line" 
      :value="value"
      class="subject-line__input form__input" 
      type="text" 
      @input="e => $emit('input', e.target.value)"
    >
  </label>
  <div 
    v-else 
    class="subject-line"
  >
    Subject: {{ value }}
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as SUBJECT_DISPLAY_TYPES from "Constants/campaign/emailSubjectDisplayTypes";

export default {
  name: "SubjectLine",
  props: {
    value: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState("campaign", {
      displayType: "emailSubjectLineDisplayType"
    }),
    isEditable() {
      return this.displayType === SUBJECT_DISPLAY_TYPES.EDITABLE_SUBJECT;
    }
  }
};
</script>
